(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("textContrast", [], factory);
	else if(typeof exports === 'object')
		exports["textContrast"] = factory();
	else
		root["textContrast"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 